import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { deleteMailServer, getAllMailServers } from "../../server/server";
import { notif } from "../utils/util";
import AddMailServerModal from "./components/AddMailServerModal";
import { MailServer } from "./dto/smpt.dto";
import ConfirmationModal from "../modals/ConfirmationModal";
import { set } from "date-fns";
import HelpPageModal from "../modals/HelpPageModal";
import HelpButton from "../../common/HelpButton";

const SmtpConfig = () => {
  const [servers, setServers] = useState<MailServer[]>([]);
  const [loading, setLoading] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [editingServer, setEditingServer] = useState<null | any>(null);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [serverToDelete, setServerToDelete] = useState<null | MailServer>(null);
  const [helpModal, setHelpModal] = useState(false);

  const getServers = async () => {
    const resp = await getAllMailServers();
    if (resp.status === 200) {
      setServers(resp.data);
    } else {
      notif("Грешка при учитавању СМТП сервера", "error");
    }
  };

  const handleNewServerSaved = () => {
    setOpenAddModal(false);
    setEditingServer(null);
    getServers();
  };

  useEffect(() => {
    getServers();
  }, []);

  const openDeleteConfirmation = (server: MailServer) => {
    setServerToDelete(server);
    setDeleteModalIsOpen(true);
  };

  const deleteServer = async (server: MailServer | null) => {
    if (!server) return;
    setLoading(true);
    const resp = await deleteMailServer(server.id);
    if (resp.status === 200) {
      notif("СМТП сервер обрисан успешно", "success");
      getServers();
    } else {
      notif("Грешка при брисању СМТП сервера", "error");
    }
    setLoading(false);
    setDeleteModalIsOpen(false);
    setServerToDelete(null);
  };
  return (
    <div className="py-10 px-2 overflow-auto gray-small-scroll h-full w-full">
      <div className="flex gap-6 justify-between pr-10">
        <h1 className="text-[#04438b] text-4xl font-bold">
          Конфигурација СМТП сервера
        </h1>
        <HelpButton onClick={() => setHelpModal(true)} />
      </div>
      <div>
        <div className="mt-8">
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenAddModal(true)}
          >
            Додај нови СМТП сервер
          </Button>
        </div>
        <div className="rounded-lg border border-[#81848f3d] p-8 mt-8 flex-grow">
          {servers.length === 0 ? (
            <div className="mt-6 text-gray-600">
              Нема доступних СМТП сервера.
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {servers.map((server) => (
                <div
                  key={server.id}
                  className="bg-white overflow-hidden shadow rounded-lg"
                >
                  <div className="p-6">
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg font-medium text-gray-900 truncate">
                        {server.name}
                      </h3>
                      {/* <span
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full`}
                    >
                      {server.purpose.replace("_", " ")}
                    </span> */}
                    </div>
                    <div className="mt-4 space-y-2 text-sm text-gray-600">
                      <div>
                        <span className="font-medium">Хост:</span> {server.host}
                        :{server.port}
                      </div>
                      <div>
                        <span className="font-medium">Корисничко име:</span>{" "}
                        {server.username}
                      </div>
                      <div>
                        <span className="font-medium">Пошиљалац:</span>{" "}
                        {server.from}
                      </div>
                    </div>

                    <div className="flex flex-row justify-between items-center w-full mt-6">
                      <div
                        className="bg-darkBlue cursor-pointer flex items-center justify-center text-white hover:opacity-90 text-base font-semibold rounded-lg w-[200px] h-[50px]"
                        onClick={() => openDeleteConfirmation(server)}
                      >
                        Брисање
                      </div>
                      <div
                        className="border border-[#81848f] hover:bg-[#81848f] hover:text-white cursor-pointer flex items-center justify-center border-redError text-redError text-base font-semibold rounded-lg w-[200px] h-[50px]"
                        onClick={() => setEditingServer(server)}
                      >
                        Измена
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <AddMailServerModal
        isOpen={openAddModal}
        onClose={() => {
          setOpenAddModal(false);
          setEditingServer(null);
        }}
        onSave={handleNewServerSaved}
        editingServer={editingServer}
      />

      <ConfirmationModal
        modalIsOpen={deleteModalIsOpen}
        closeModal={() => setDeleteModalIsOpen(false)}
        confirmation={() => deleteServer(serverToDelete)}
        message={`Обришите СМТП сервер?`}
      />
      <HelpPageModal
        modalIsOpen={helpModal}
        closeModal={() => setHelpModal(false)}
        name={"smtpConfig"}
      />
    </div>
  );
};

export default SmtpConfig;
